/* eslint-disable prettier/prettier */
import { createSlice } from "@reduxjs/toolkit";
import { act } from "react";
import _ from "lodash";

export const solicitudesSlice = createSlice({
  name: "solicitud",
  initialState: {
    solicitudes: [],
    catalogos: [],
    isloadingCatalogos: true,
    isloadingSolicitudes: false,
    catFiltros: [],
    isLoadingCracion: false,
    isLoadingExito: false,
    messageError: [],
    intentosDeSolicitud: [],
    isloadingIntentoSolicitud: false,
    countNotificacionesNoLeidas: 0,
    NotificacionesSeparadas: [],
    isloadingMostrarNotificaciones: false,
    detalleSolicitud: {},
    isloadingdetalleSolicitud: false,
    docsReunionBoston: [],
    docsReunionNacional: [],
    documentacionClinica: [],
    estudiosSE: [],
    isloadingGaleria: false,
    procesoExitoso : false
  },
  reducers: {
    setData: (state, action) => {
      state.solicitudes = action.payload;
    },
    isLoading: (state, action) => {
      state.isloadingSolicitudes = action.payload;
    },
    setCatalogos: (state, action) => {
      state.catalogos = action.payload;
      state.isloadingCatalogos = false;
    },
    setInformacionI: (state, action) => {
      state.catFiltros = action.payload;
    },
    setIsloadingCreacion: (state, action) => {
      state.isLoadingCracion = action.payload;
    },
    setIsloadingExito: (state, action) => {
      state.isLoadingExito = action.payload;
    },
     setProcesoTerminadoExitoso: (state, action) => {
      state.procesoExitoso = action.payload;
    },
    setMessageCreacion: (state, action) => {
      state.messageError.push(action.payload);
    },
    setDataIntentosSolicitud: (state, action) => {
      state.intentosDeSolicitud = action.payload;
    },
    SetisloadingIntentoSolicitud: (state, action) => {
      state.isloadingIntentoSolicitud = action.payload;
    },
    setNotificacionesNoLeidas: (state, action) => {
      state.countNotificacionesNoLeidas = action.payload;
    },
    setNotificacionesSeparadas: (state, action) => {
      state.NotificacionesSeparadas = action.payload;
    },
    setisloadingNotificacionesSeparadas: (state, action) => {
      state.isloadingMostrarNotificaciones = action.payload;
    },
    setDetalleSolitud: (state, action) => {
      state.detalleSolicitud = action.payload;
    },
    setisloadingdetalleSolicitud: (state, action) => {
      state.isloadingdetalleSolicitud = action.payload;
    },
    cleanMessageCreacion: (state, action) => {
      state.messageError = [];
    },
    setNotificaciones: (state, action) => {
      state.solicitudes = state.solicitudes.map((item) => {
        if (item.idSolicitud === action.payload.id) {
          return {
            ...item,
            loading: action.payload.estatus,
            notificaciones: action.payload.data,
            tieneNotificacionesPendientes: false,
          };
        }
        return item;
      });
    },
    setisloadingGaleria: (state, action) => {
      state.isloadingGaleria = action.payload;
    },
    setGaleria: (state, action) => {
      state.detalleSolicitud = { ...state.detalleSolicitud, galeria: action.payload };
    },
    setAddGaleria: (state, action) => {
      state.detalleSolicitud.galeria.unshift(action.payload);
    },
    removeGaleria: (state, action) => {
      const idGaleria = action.payload;
      state.detalleSolicitud.galeria = state.detalleSolicitud.galeria.filter(
        (imagen) => imagen.idGaleria !== idGaleria
      );
    },
    UpdateDetalleSolitudEstatusDocumentos: (state, action) => {
      state.detalleSolicitud[action.payload.campo] = action.payload.valor;
    },
    setDocumentacionSolicitud: (state, action) => {
      state.docsReunionBoston = action.payload?.docsReunionBoston ?? [];
      state.docsReunionNacional = action.payload?.docsReunionNacional ?? [];
      state.documentacionClinica = action.payload?.documentacionClinica ?? [];
      state.estudiosSE = action.payload?.estudiosSE ?? [];
    },
    resetDocumentacionSolicitud: (state) => {
      state.docsReunionBoston = [];
      state.docsReunionNacional = [];
      state.documentacionClinica = [];
      state.estudiosSE = [];
    },
    UpdateStatusArchivos: (state, action) => {
      if (action.payload.tabla == "clinica") {
        state.documentacionClinica = state.documentacionClinica.map((item) => {
          if (item.idDocumentacionClinica === action.payload.id) {
            return {
              ...item,
              estado: action.payload.valor,
            };
          }
          return item;
        });
      }
      if (action.payload.tabla == "estudio") {
        state.estudiosSE = state.estudiosSE.map((item) => {
          if (item.idEstudioSE === action.payload.id) {
            return {
              ...item,
              estado: action.payload.valor,
            };
          }
          return item;
        });
      }
      if (action.payload.tabla == "nacional") {
        state.docsReunionNacional = state.docsReunionNacional.map((item) => {
          if (item.idDocReunionNacional === action.payload.id) {
            return {
              ...item,
              estado: action.payload.valor,
            };
          }
          return item;
        });
      }
      if (action.payload.tabla == "boston") {
        state.docsReunionBoston = state.docsReunionBoston.map((item) => {
          if (item.idDocReunionBoston === action.payload.id) {
            return {
              ...item,
              estado: action.payload.valor,
            };
          }
          return item;
        });
      }
    },
    udateLaadingDescargaArchivo: (state, action) => {
      if (action.payload.tabla == "clinica") {
        state.documentacionClinica = state.documentacionClinica.map((item) => {
          if (item.idDocumentacionClinica === action.payload.id) {
            return {
              ...item,
              loading: action.payload.valor,
            };
          }
          return item;
        });
      }
      if (action.payload.tabla == "estudio") {
        state.estudiosSE = state.estudiosSE.map((item) => {
          if (item.idEstudioSE === action.payload.id) {
            return {
              ...item,
              loading: action.payload.valor,
            };
          }
          return item;
        });
      }
      if (action.payload.tabla == "nacional") {
        state.docsReunionNacional = state.docsReunionNacional.map((item) => {
          if (item.idDocReunionNacional === action.payload.id) {
            return {
              ...item,
              loading: action.payload.valor,
            };
          }
          return item;
        });
      }
      if (action.payload.tabla == "boston") {
        state.docsReunionBoston = state.docsReunionBoston.map((item) => {
          if (item.idDocReunionBoston === action.payload.id) {
            return {
              ...item,
              loading: action.payload.valor,
            };
          }
          return item;
        });
      }
    },
    updateDeleteSolicitudes: (state, action) => {
      _.remove(state.solicitudes, (s) => s.idSolicitud === action.payload);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setData,
  isLoading,
  setCatalogos,
  setInformacionI,
  setIsloadingCreacion,
  setIsloadingExito,
  setProcesoTerminadoExitoso,
  setMessageCreacion,
  setDataIntentosSolicitud,
  SetisloadingIntentoSolicitud,
  setNotificacionesNoLeidas,
  setNotificacionesSeparadas,
  setisloadingNotificacionesSeparadas,
  setDetalleSolitud,
  setAddGaleria,
  removeGaleria,
  setisloadingdetalleSolicitud,
  cleanMessageCreacion,
  setNotificaciones,
  setGaleria,
  UpdateDetalleSolitudEstatusDocumentos,
  setDocumentacionSolicitud,
  resetDocumentacionSolicitud,
  UpdateStatusArchivos,
  udateLaadingDescargaArchivo,
  updateDeleteSolicitudes,
  setisloadingGaleria,
} = solicitudesSlice.actions;

export default solicitudesSlice.reducer;
